module.exports = __webpack_public_path__ + "img/shu_4.18a1fc16.png";